/** 메뉴 양옆에 늘 남기는 최소 틈(marketing-site-shell 「머리말 구성」) — 폭이 줄어도 메뉴가 로고·오른쪽 묶음에 붙지 않는다 */
export const NAV_SIDE_MIN_GAP_PX = 48;

const LOGO_WIDTH_PX = 168;
/** 안쪽 틀 한쪽 여백 */
export const HEADER_INNER_PADDING_PX = { wide: 32, narrow: 20 } as const;

/** 폭(px) — [넓은 간격, 좁힌 간격] */
type SpacingWidths = readonly [wide: number, narrow: number];

export type HeaderSession = "signedOut" | "signedIn" | "flightHub";
const HEADER_SESSIONS: readonly HeaderSession[] = [
  "signedOut",
  "signedIn",
  "flightHub",
];

/**
 * 메뉴(`nav`)와 오른쪽 묶음(로그인 전·뒤·관제 버튼이 있는 계정)의 실측 폭. 메뉴·버튼 글자가 바뀌면 다시 잰다 —
 * 이 표가 넘어가는 폭을 정하므로, 어긋난 만큼 틈이 줄거나 메뉴 버튼으로 일찍 넘어간다.
 */
const MEASURED_WIDTHS_PX = {
  ko: {
    nav: [524, 456],
    signedOut: [279, 273],
    signedIn: [398, 392],
    flightHub: [582, 577],
  },
  en: {
    nav: [544, 475],
    signedOut: [300, 293],
    signedIn: [442, 435],
    flightHub: [647, 641],
  },
  ja: {
    nav: [678, 600],
    signedOut: [297, 291],
    signedIn: [406, 401],
    flightHub: [632, 626],
  },
  km: {
    nav: [691, 612],
    signedOut: [312, 304],
    signedIn: [409, 402],
    flightHub: [572, 564],
  },
} as const satisfies Record<
  string,
  Record<"nav" | HeaderSession, SpacingWidths>
>;

/**
 * 폭이 줄 때 배치가 넘어가는 경계(이 폭 아래에서 해당 배치). 정중앙 → `between`(남는 폭의 가운데) → `narrow`(좁힌 간격) →
 * `compact`(메뉴 버튼). 정중앙에서는 양옆 칸이 같은 폭이라 로고보다 넓은 오른쪽 묶음 쪽 틈이 먼저 줄어든다.
 */
export const headerBreakpointsFor = (
  nav: SpacingWidths,
  right: SpacingWidths
) => {
  const { wide, narrow } = HEADER_INNER_PADDING_PX;
  return {
    between: nav[0] + 2 * (right[0] + wide + NAV_SIDE_MIN_GAP_PX),
    narrow:
      LOGO_WIDTH_PX + nav[0] + right[0] + 2 * (wide + NAV_SIDE_MIN_GAP_PX),
    compact:
      LOGO_WIDTH_PX + nav[1] + right[1] + 2 * (narrow + NAV_SIDE_MIN_GAP_PX),
  };
};

/** 언어·로그인 상태별 경계 */
export const HEADER_BREAKPOINTS_PX = Object.entries(MEASURED_WIDTHS_PX).flatMap(
  ([lang, widths]) =>
    HEADER_SESSIONS.map((session) => ({
      lang,
      session,
      ...headerBreakpointsFor(widths.nav, widths[session]),
    }))
);
